import React from "react";

const Footer = () => {
  const dat = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://simpleelabs.com/" target="_blank"  rel="noreferrer">
          SimpleeLabs
          </a>{" "}
          {dat.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
